import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {contentFeedItemsApi} from 'common/src/modules/contentFeedItems/contentFeedItems.api';
import {UpdateDraftItemRequest} from '../../../contentFeeds.types';
import {loadDraftItems} from './loadDraftItems.thunk';

interface UpdateDraftItemEntry {
  feedId: number;
  itemId: number;
  request: UpdateDraftItemRequest;
}

export const updateDraftItems = createAsyncThunk(
  `${BreadcrumbName.ContentFeedPage}/updateDraftItems`,
  async (entries: UpdateDraftItemEntry[], {dispatch}) => {
    await Promise.all(
      entries.map(({feedId, itemId, request}) => contentFeedItemsApi.updateDraftItem(feedId, itemId, request)),
    );

    if (entries.length > 0) {
      await dispatch(loadDraftItems({feedId: entries[0].feedId, forceReload: true})).unwrap();
    }
  },
);
